import { gql, TypedDocumentNode } from "@apollo/client";
import type { Interaction } from "@/components/interactions";

export type CRMInteractionQueryResponse = {
  crmInteraction: Interaction | null;
};

export type CRMInteractionQueryVariables = {
  id: string;
};

export const CRM_INTERACTION_QUERY: TypedDocumentNode<CRMInteractionQueryResponse, CRMInteractionQueryVariables> = gql`
  query CRMInteractionQuery($id: ID!) {
    crmInteraction(id: $id) {
      id
      createdAt
      categories
      owner {
        name
        email
      }
      showAiSummary
      messages {
        content
        createdAt
        isPrivate
        fromOwner
        haveAccess
      }
      lastMessage {
        content
        createdAt
        isPrivate
        fromOwner
        haveAccess
      }
      jobPost {
        id
        name
        category {
          name
        }
        facility {
          name
        }
      }
      lastModifiedDate
      interactionDate
      messagesCount
      mode
      participants {
        firstName
        lastName
        profilePhoto
        pgaId
        currentStatus
        classification
        employments {
          isPrimary
          facility {
            name
          }
        }
        primarySectionAffiliation {
          section {
            name
          }
        }
      }
      summary
      relatedTo
      openTasksCount
      _permissions
    }
  }
`;
